import { Swiper, SwiperSlide } from "swiper/react"
import { Autoplay, EffectFade } from "swiper"
import { useState } from "react"
import { convertJson, imgUrl } from "src/mixins"
import { Image } from "@components/anti/Image"

export function ServicesCover({ data, locale }) {
  // store swiper instance
  const [swiperIndex, setSwiperIndex] = useState(0)

  return (
    <section className="sc-services-cover">
      <div className="pagination-wrapper py-4 py-md-5">
        <div className="container h-100">
          <div className="services-pagination">
            {convertJson(data?.slideshow).map((item, i) => (
              <div
                className={`pagination-item ${
                  i === swiperIndex ? "active" : ""
                }`}
                key={i}
              />
            ))}
          </div>
        </div>
      </div>
      <Swiper
        // onSwiper={setSwiper}
        spaceBetween={20}
        slidesPerView={1}
        className="services-swiper"
        onSlideChange={(val) => setSwiperIndex(val.activeIndex)}
        modules={[Autoplay, EffectFade]}
        effect="fade"
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
      >
        {convertJson(data?.slideshow).map((item, i) => (
          <SwiperSlide key={i}>
            <div className="services-wrapper">
              <Image
                src={imgUrl(item?.banner_image_mobile)}
                className="d-block d-md-none img-services img-fluid"
                alt="Image"
                fill
                priority
              />
              <Image
                src={imgUrl(item?.banner_image_desktop)}
                className="d-none d-md-block img-services img-fluid"
                alt="Image"
                fill
                priority
              />
              <div className="services-body">
                <div className="container h-100 py-5">
                  <h2 className="h1 w-400px mr-4 mr-md-0">
                    {data && data[`title_${locale}`]}
                  </h2>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  )
}
